// MST timezone helpers + pay period math (mirror of backend logic)
export const MST_TZ = "America/Edmonton";

export const formatMST = (iso, opts = {}) => {
  if (!iso) return "—";
  const d = typeof iso === "string" ? new Date(iso) : iso;
  return new Intl.DateTimeFormat("en-US", {
    timeZone: MST_TZ,
    ...opts,
  }).format(d);
};

export const formatMSTDateTime = (iso) =>
  formatMST(iso, { dateStyle: "medium", timeStyle: "short" });

export const formatMSTTime = (iso) =>
  formatMST(iso, { timeStyle: "medium" });

export const formatMSTDate = (iso) =>
  formatMST(iso, { dateStyle: "medium" });

export const formatDuration = (totalSeconds) => {
  const s = Math.max(0, Math.floor(totalSeconds));
  const hh = String(Math.floor(s / 3600)).padStart(2, "0");
  const mm = String(Math.floor((s % 3600) / 60)).padStart(2, "0");
  const ss = String(s % 60).padStart(2, "0");
  return `${hh}:${mm}:${ss}`;
};

export const minutesToHours = (m) => Math.round((m / 60) * 100) / 100;

export const dayShortMST = (isoDateOnly) => {
  // isoDateOnly = "YYYY-MM-DD"
  const d = new Date(`${isoDateOnly}T12:00:00Z`);
  return {
    short: new Intl.DateTimeFormat("en-US", { timeZone: MST_TZ, weekday: "short" }).format(d),
    dayNum: new Intl.DateTimeFormat("en-US", { timeZone: MST_TZ, day: "numeric" }).format(d),
    month: new Intl.DateTimeFormat("en-US", { timeZone: MST_TZ, month: "short" }).format(d),
  };
};
